import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { TestingSelectModalContext } from "context/testingSelectModalContext";
import { CompanyContext } from "context/companyContext";
import { generateUnavailableText } from "components/buttons/ButtonWithPermissions";
import PageHeader from "components/PageHeader";

const Header = () => {
  const navigate = useNavigate();
  const { isCreateAvailable, currentCompany } = useContext(CompanyContext);
  const { handleOpen } = useContext(TestingSelectModalContext);

  const createAssessmentUnavailableText = generateUnavailableText(
    isCreateAvailable,
    currentCompany,
    "создания тестирования"
  );

  const handleCreateButtonClick = () => {
    handleOpen({ navigate });
  };
  return (
    <PageHeader
      title='Тестирования'
      mainButtonProps={{
        buttonText: "Создать тестирование",
        tooltipText: createAssessmentUnavailableText,
        onClick: handleCreateButtonClick,
      }}
    />
  );
};

export default Header;
